import React, { useContext, useEffect, useRef, useState } from 'react'
import { Box, CircularProgress, MenuItem, Paper, TextField, Typography } from '@mui/material';
import ApiService from '../../functions/apiService';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import moment from 'moment/moment';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useReactToPrint } from "react-to-print";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import MyTable from '../Schedule/MyTable';
import AuthContext from '../../context/AuthContext';
import { Col, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import CustomSelect from '../../components/Schedule/CustomSelect';
import { setPossitionListDDL } from '../../store/ddlReducer';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { styled } from '@mui/material/styles';
import { toast } from 'react-toastify';
import { varFormatTime } from '../../utils/helperFunctions';

export default function RunCard() {
  // const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();
  const dispatch = useDispatch()
  const myteamDate = new URLSearchParams(window?.location?.search);
  const [data, setData] = useState(null);
  const [dayData, setDayData] = useState(null);
  const [nightData, setNightData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('DAY');
  const { pagesName, user } = useContext(AuthContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const routeDate = searchParams.get('date') || new Date();
  const printRef = useRef();
  const [showAlert, setShowAlert] = useState(false)
  const [positionData, setPositionData] = useState({})
  const today = moment(new Date()).format('YYYY-MM-DD')
  const newRouteDate = moment(routeDate).format('YYYY-MM-DD')
  const backUrl = newRouteDate !== today ? '/firehouse/schedule?date=' + routeDate : '/firehouse/schedule?date=' + today;
	let detailData = useSelector((state) => state.dashboardReducer.Data)
	const [detailAllData , setDetailAllData] = useState([]);

  let PossitionListDDL = useSelector((state) => state.ddlReducer.PossitionListDDL)
  let groupName = Object.keys(pagesName).includes("GROUP_HEADER_TEXT") ? pagesName.GROUP_HEADER_TEXT : "Group";

  const loadData = (loading = true) => {
    if (loading == true) {
      setLoading(true)
    }
    ApiService.get('/todayShift?date=' + moment(routeDate).format('DD-MM-YYYY'), {}, 'todayShift')
      .then(({ data }) => {
        setData(data)
        if (data) {
          var tempNightData = JSON.parse(JSON.stringify(data));
          tempNightData.stations = tempNightData.stations.map(station => ({
            ...station,
            employees: station.employees.filter(employee => employee.inNIGHTShift)
          }));
          tempNightData.dayEmployee = tempNightData.dayEmployee.map(station => ({
            ...station,
            employees: station.employees.filter(employee => employee.inNIGHTShift)
          }));
          setNightData(tempNightData)

          var tempDayData = JSON.parse(JSON.stringify(data));
          tempDayData.stations = tempDayData.stations.map(station => ({
            ...station,
            employees: station.employees.filter(employee => employee.inDayShift)
          }));
          tempDayData.dayEmployee = tempDayData.dayEmployee.map(station => ({
            ...station,
            employees: station?.employees?.filter(employee => employee.inDayShift)
          }));
          setDayData(tempDayData)
        }
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        toast.error("Error")
        // enqueueSnackbar('Error', { variant: 'error' });
      })
  }

  const loadDropdown = () => {
    ApiService.get('/getPositionListDDL', {}, 'getPositionListDDL')
      .then(({ data }) => {
        dispatch(setPossitionListDDL(data));
      })
      .catch((err) => {
        console.log('err', err)
      })
  }

  useEffect(() => {
    loadData()
    loadDropdown()
  }, [])

	useEffect(() => {
    ApiService.get('/todayDetails', { date: detailData.date }, 'todayDetails').then(({ data }) => {
      setDetailAllData(data?.data || [])
    })
  }, [data])

  // removed on 26-02-2025, might need later
  // let loadData = (date, url = '/scheduleRuncard?date=') => {
  //   ApiService.get(url + date).then(({ data }) => {
  //     setData(data.data)
  //     setLoading(false)
  //   }).catch(() => {
  //     setLoading(false)
  //     enqueueSnackbar('Error', { variant: 'error' });
  //   })
  // }
  // useEffect(() => {
  //   if (myteamDate.get('myteamDate')) {
  //     setBackUrl('/firehouse/myTeam')
  //     loadData(myteamDate.get('myteamDate'), '/scheduleRuncardMyTeam?date=');
  //   } else if (dashboardData == '') {
  //     navigate('/firehouse/schedule')
  //   } else {
  //     loadData(dashboardData.date);
  //   }
  // }, [])

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  let printFunction = () => {
    handlePrint()
  }

  const getEmpNameStyle = (params, type = 'day') => {
    let color = params.row.EA_Status === 'N' ? 'orange' : 'inherit'
    let textEmployee = `${params.row.EA_Rank} ${params.row.fullName}`
    let reason = ''

    if (type == 'night') {
      if (params?.row?.customShiftsArrayNight?.length > 0) {
        return (
          <>
            <div className={`${(params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}>
              {textEmployee}
            </div>
            {params?.row?.customShiftsArrayNight.map((shift) => {
              reason = shift.absentReason
              textEmployee = `, Open Position (${varFormatTime(shift.custom_time, user?.Time_Format)})`
              if (shift.dayStatus == 'F') {
                reason = ''
                textEmployee = `${shift.DayFillEmpFirst_name} ${shift.DayFIllEmpLast_name} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
              }
              let color = 'inherit'
              if (shift.absentColor == 'red') {
                color = '#E62719'
              } else if (shift.absentColor == 'orange') {
                color = 'orange'
              } else if (shift.absentColor == 'green') {
                color = '#079E46'
              } else if (shift.absentColor == 'blue') {
                color = '#8cbaf9'
              }
              return (
                <div className={`${(params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
                  style={{
                    color: color,
                    fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    textOverflow: 'ellipsis',
                  }}>
                  <span style={{ fontWeight: 'bold' }}>{reason}</span>
                  {textEmployee}
                </div>
              )
            })}
          </>
        )
      }
      else {
        if (params.row.nightStatus === "F" && params.row.NightFillEmpFirst_name) {
          textEmployee = `${params.row.EA_Rank} ${params.row.NightFillEmpFirst_name} ${params.row.NightFIllEmpLast_name}`;
          color = '#079E46';
        }
        if (params.row.nightStatus === "O") {
          reason = params.row.absentReasonNight;
          textEmployee = `, Open Position`;
          color = '#E62719';
        }
        if (params.row.nightStatus === "D") {
          reason = params.row.absentReasonNight;
          textEmployee = `, Open Position`;
          color = '#000000';
        }
        if (params.row.nightStatus === "Q") {
          reason = params.row.absentReasonNight;
          textEmployee = `, Open Position`;
          color = '#FFA500';
        }

        return (
          <div className={`${(params?.row?.customShiftsArrayNight?.length > 0) && 'shift-arr'}`}
            style={{
              color: color,
              fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              textOverflow: 'ellipsis',
            }}>
            <span style={{ fontWeight: 'bold' }}>{reason}</span>
            {textEmployee}
          </div>
        );
      }
    }
    else {
      if (params?.row?.customShiftsArrayDay?.length > 0) {
        return (
          <>
            <div className={`${(params?.row?.customShiftsArrayDay?.length > 0) && 'shift-arr'}`}>
              {textEmployee}
            </div>
            {params?.row?.customShiftsArrayDay.map((shift) => {
              reason = shift.absentReason
              textEmployee = `, Open Position (${varFormatTime(shift.custom_time, user?.Time_Format)})`
              if (shift.dayStatus == 'F') {
                reason = ''
                textEmployee = `${shift.DayFillEmpFirst_name} ${shift.DayFIllEmpLast_name} (${varFormatTime(shift.custom_time, user?.Time_Format)})`
              }
              let color = 'inherit'
              if (shift.absentColor == 'red') {
                color = '#E62719'
              } else if (shift.absentColor == 'orange') {
                color = 'orange'
              } else if (shift.absentColor == 'green') {
                color = '#079E46'
              } else if (shift.absentColor == 'blue') {
                color = '#8cbaf9'
              }
              return (
                <div className={`${(params?.row?.customShiftsArrayDay?.length > 0) && 'shift-arr'}`}
                  style={{
                    color: color,
                    fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
                    whiteSpace: 'normal',
                    wordBreak: 'break-word',
                    textOverflow: 'ellipsis',
                  }}>
                  <span style={{ fontWeight: 'bold' }}>{reason}</span>
                  {textEmployee}
                </div>
              )
            })}
          </>
        )
      }
      else {
        if (params.row.dayStatus === "F" && params.row.DayFillEmpFirst_name) {
          textEmployee = `${params.row.EA_Rank} ${params.row.DayFillEmpFirst_name} ${params.row.DayFIllEmpLast_name}`;
          color = '#079E46';
        }
        if (params.row.dayStatus === "O") {
          reason = params.row.absentReason;
          textEmployee = `, Open Position`;
          color = '#E62719';
        }
        if (params.row.dayStatus === "D") {
          reason = params.row.absentReason;
          textEmployee = `, Open Position`;
          color = '#000000';
        }
        if (params.row.dayStatus === "Q") {
          reason = params.row.absentReason;
          textEmployee = `, Open Position`;
          color = '#FFA500';
        }

        return (
          <div className={`${(params?.row?.customShiftsArrayDay?.length > 0) && 'shift-arr'}`}
            style={{
              color: color,
              fontWeight: params.row.EA_Status === 'N' ? 'bold' : 'normal',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              textOverflow: 'ellipsis',
            }}>
            <span style={{ fontWeight: 'bold' }}>{reason}</span>
            {textEmployee}
          </div>
        );
      }
    }
  }

  const options = PossitionListDDL.map((i) => ({
    value: i.SO_Value,
    label: i.SO_Desc,
    dataAssignment: i?.resource_assignment,
  }));

  const columns = (type = 'day') => {
    let column = [
      {
        field: 'PositionName', headerName: 'Unit', flex: 1, minWidth: 220, maxwidth: 300,
        renderCell: (params) => {
          const defaultOption = options.find((opt) => opt.value === params.row.Position_Code);
          var bg = '#e9e9ed'
          return (
            <div>
              <div className='print-name'>
                {params?.row?.PositionName}
              </div>
              <div className='print-drop'>
                <CustomSelect
                  options={options}
                  defaultOption={defaultOption}
                  isDisabled={false}
                  isLoading={false}
                  isRtl={false}
                  isSearchable={true}
                  name="Possition"
                  onChange={(e) => handleSelectChange(e, params?.row, type)}
                  bgColor={bg}
                  value={defaultOption}
                />
              </div>
            </div>
          )
        },
      },
      {
        field: 'fullName', headerName: 'Name', flex: 1, minWidth: 120,
        renderCell: (params) => getEmpNameStyle(params, type),
      },
    ]
    return column
  }

	let columns2 = [
    {
      field: "ShiftName",
      headerName: "Shift",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "DetailType",
      headerName: "Detail Type",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "AssignmentText",
      headerName: "Assignment",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "PositionName",
      headerName: "Rank",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "EMT",
      headerName: "EMT",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "StatusText",
      headerName: "Status",
      flex: 1,
      minWidth: 200,
    },
  ]

  const handleSelectChange = (e, row, day) => {
    const posObj = {
      e: e,
      emp: row,
      day: day
    }
    setPositionData(posObj)
    setShowAlert(true)
  };

  let changeEmpPossion = () => {
    if (positionData.emp.Position_Code == positionData.e.value) {
      toast.error("Same Position")
      // enqueueSnackbar('Same position', { variant: 'error' });
    }
    else if (!positionData.e.dataAssignment) {
      toast.error("No assignment for this position")
      // enqueueSnackbar('No assignment for this position', { variant: 'error' });
    }
    else {
      ApiService.post('/changeEmployeeSchedule', {
        "EmpCode": positionData.emp.Emp_Code,
        "Possition": positionData.e.value,
        "Assignment": positionData.e.dataAssignment.Assignment,
        "Vehicle": positionData.e.dataAssignment.Vehicle || null,
        "ShiftDate": data.date,
        "ShiftCode": positionData.day == 'day' ? 2 : 3
      }).then(() => {
        loadData()
      }).catch(({ error }) => {
        console.log('error', error)
      });
    }
    setShowAlert(false)
  }

  const filterView = (e, val) => {
    setFilter(val)
    localStorage.setItem('runcardFilter', val)
  }

  useEffect(() => {
    if (localStorage.getItem('runcardFilter')) {
      setFilter(localStorage.getItem('runcardFilter'))
    }
  }, [])

  const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    width: 40,
    height: 48,
    textTransform: 'none',
    border: '1px solid #ccc',
    backgroundColor: '#ffffff',
    borderRadius: '60px',
    '&.Mui-selected': {
      backgroundColor: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 1)' : '1px solid rgba(224, 224, 224, 1)',
      color: '#fff',
      '&:hover': {
        backgroundColor: theme.palette.mode === 'dark' ? '1px solid rgba(224, 224, 224, 1)' : '1px solid rgba(224, 224, 224, 1)',
      },
    },
  }));

  return (
    <>
      <Paper className='my-3 pb-4'>
        <div className='p-4'>
          <Box>
            <Link 
						// to={routeDate != '' ? '/firehouse/schedule?date=' + moment(routeDate).format('YYYY-MM-DD') : '/firehouse/schedule'} 
						to='/firehouse/my-team'
						style={{ color: '#555555' }}> 
						<ArrowBackIosIcon /><span className='fw-500'>Back</span></Link>
          </Box>
          <div className='d-flex align-items-center'>
            <Typography variant="h6" className="my-2">
              {routeDate != '' && moment(routeDate).format("dddd Do MMMM YYYY") + ' - ' + groupName}
            </Typography>

            <div style={{ marginLeft: 'auto', gap: 20, alignItems: 'center', display: 'flex' }}>
              <ToggleButtonGroup
                value={filter}
                exclusive
                onChange={(e, val) => filterView(e, val)}
                aria-label="toggle mode"
              >
                <StyledToggleButton value="DAY">
                  <img src='/images/day.svg' height='20px' width='20px' />
                </StyledToggleButton>
                <StyledToggleButton value="NIGHT">
                  <img src='/images/night.svg' height='20px' width='20px' />
                </StyledToggleButton>
                <StyledToggleButton value="24HOUR">
                  <img src='/images/fullhour.svg' height='24px' width='24px' />
                </StyledToggleButton>
              </ToggleButtonGroup>

              <ButtonTheme onClick={printFunction} color='primary'>
                Print
              </ButtonTheme>
            </div>
          </div>
        </div>
        {loading ?
          <Box sx={{ minHeight: '200px' }} className="w-100 h-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </Box>
          :
          <>
            <div ref={printRef} className='px-4'>
              <Row>
                <Col md={12} className='print-header'>
                  <div className='d-flex align-items-center justify-content-between'>
                    Firehouse247
                    <div className='text-center'>
                      <h4>Schedule report</h4>
                      {routeDate != '' && moment(routeDate).format("dddd MMMM DD, YYYY")}
                    </div>
                    <img src='/images/black-logo.png' style={{ width: 60, height: 60 }} />
                  </div>
                </Col>
                {(filter == 'DAY' || filter == '24HOUR') &&
                  <Col md={6} className='print-width'>
                    <Box>
                      <div className='p-3 mt-4'
                        style={{
                          backgroundColor: '#cb243d', color: '#fff', borderTopLeftRadius: 15,
                          borderTopRightRadius: 15
                        }}>
                        <h3>Day</h3>
                      </div>
                      {dayData && dayData.stations.map((station) => (
                        <Box className='page-break-never' style={{ borderColor: '#e0e0e0', borderWidth: 1, borderStyle: 'solid' }}>
                          <div
                            style={{
                              borderBottomColor: '#e0e0e0', borderBottomWidth: 1,
                              borderBottomStyle: 'solid', padding: 15, paddingLeft: 10, fontWeight: 600,
                            }}>
                            {station.name}
                          </div>
                          <MyTable
                            key={station.name}
                            rows={station.employees}
                            columns={columns('day')}
                            checkboxSelection={false}
                            hideFooter={true}
                            showHeader={false}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Col>
                }

                {(filter == 'NIGHT' || filter == '24HOUR') &&
                  <Col md={6} className='print-width'>
                    <Box>
                      {filter == '24HOUR' &&
                        <div className="page-break" />
                      }
                      <div className='p-3 mt-4' style={{
                        backgroundColor: '#23314a', color: '#fff', borderTopLeftRadius: 15,
                        borderTopRightRadius: 15
                      }}>
                        <h3>Night</h3>
                      </div>
                      {nightData && nightData.stations.map((station) => (
                        <Box className='page-break-never' style={{ borderColor: '#e0e0e0', borderWidth: 1, borderStyle: 'solid' }}>
                          <div style={{
                            borderBottomColor: '#e0e0e0', borderBottomWidth: 1,
                            borderBottomStyle: 'solid', padding: 15, paddingLeft: 10, fontWeight: 600
                          }}>
                            {station.name}
                          </div>
                          <MyTable
                            key={station.name}
                            rows={station.employees}
                            columns={columns('night')}
                            checkboxSelection={false}
                            hideFooter={true}
                            showHeader={false}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Col>
                }

								{detailAllData.length > 0 &&
                  <Col md={12} className='print-width'>
                    <Box>
											<div className='p-3 mt-4'
                        style={{
                          backgroundColor: '#555555', color: '#fff', borderTopLeftRadius: 15,
                          borderTopRightRadius: 15
                        }}>
                        <h3>Details</h3>
                      </div>
												
											<Row>
												{detailAllData?.map((item) => (
													<Col md={6} className='print-width'>
														<Box className='page-break-never' style={{marginTop:'20px' , border:'1px solid #e0e0e0' , padding:'12px'}}>
															<div style={{borderBottom:'1px solid #EAECF0' , paddingBottom:'10px'}}>
																<p style={{marginTop:'0px' , marginBottom:'0px' , color:'#555555'}}>Shift : <span style={{color:'#000000'}}>{item.ShiftName}</span></p>
															</div>
															<div style={{borderBottom:'1px solid #EAECF0' , padding:'10px 0px'}}>
																<p style={{marginTop:'0px' , marginBottom:'0px' , color:'#555555'}}>Detail Type : <span style={{color:'#000000'}}>{item.DetailType}</span></p>
															</div>
															<div style={{borderBottom:'1px solid #EAECF0' , padding:'10px 0px'}}>
																<p style={{marginTop:'0px' , marginBottom:'0px' , color:'#555555'}}>Assignment : <span style={{color:'#000000'}}>{item.AssignmentText}</span></p>
															</div>
															<div style={{borderBottom:'1px solid #EAECF0' , padding:'10px 0px'}}>
																<p style={{marginTop:'0px' , marginBottom:'0px' , color:'#555555'}}>Description : <span style={{color:'#000000'}}>{item.DetailText}</span></p>
															</div>
															<div style={{borderBottom:'1px solid #EAECF0' , padding:'10px 0px'}}>
																<p style={{marginTop:'0px' , marginBottom:'0px' , color:'#555555'}}>Rank : <span style={{color:'#000000'}}>{item.PositionName}</span></p>
															</div>
															<div style={{borderBottom:'1px solid #EAECF0' , padding:'10px 0px'}}>
																<p style={{marginTop:'0px' , marginBottom:'0px' , color:'#555555'}}>EMT : <span style={{color:'#000000'}}>{item.EMT}</span></p>
															</div>
															<div style={{paddingTop:'10px'}}>
																<p style={{marginTop:'0px' , marginBottom:'0px' , color:'#555555'}}>Status : <span style={{color:'#000000'}}>{item.StatusText}</span></p>
															</div>
														</Box>
													</Col>
												))}
											</Row>
                    </Box>
                  </Col>
                }
              </Row>
            </div>
          </>
        }
        {showAlert &&
          <SweetAlert
            warning
            showCancel
            confirmBtnText="Confirm"
            confirmBtnBsStyle="danger"
            title="Employee Re-assignment"
            onConfirm={changeEmpPossion}
            onCancel={() => {
              loadData(false);
              setShowAlert(false)
            }}
            focusCancelBtn
          >
            Are you sure you want to re-assign this position?
          </SweetAlert>
        }
      </Paper>
    </>
  )
}
